import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routesRoot } from './old-app-routing.module';

import { OldViewComponent } from './old-view.component';

const routes: Routes = [
  { path: '', component: OldViewComponent, children: routesRoot },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OldViewRoutingModule {}
